import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type FileUploadResponse = {
  mediaId: string
  ownerId: string
  location: string
  filename: string
  mimeType: string
}

export function useUploadFile() {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData()
      formData.append('file', file)

      const { data } = await apiClient.post<FileUploadResponse>(`/int/v3/media`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000,
      })
      return data
    },
  })
}

type PublicUploadFileProps = {
  mediaFile: File
  cameraName: string
  timestamp: string
}

export function usePublicUploadFile() {
  return useMutation({
    mutationFn: async ({ cameraName, mediaFile, timestamp }: PublicUploadFileProps) => {
      const formData = new FormData()
      formData.append('mediaFile', mediaFile)
      formData.append('cameraName', cameraName)
      formData.append('timestamp', timestamp)

      const { data } = await apiClient.post<{ mediaId: string; url: string }>(`/v2/media`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000,
      })
      return data
    },
  })
}
